/**
 * What the 90-day deletion clears next (M37-T02). amtc_admin only. Carries no
 * name or phone number, by design: a list of what is about to be deleted must
 * not become another copy of it.
 */
import { apiFetch } from './client'

export type DueForDeletionItem = {
  queue: 'coordination' | 'old_flow'
  reference: string
  created_at: string
  /** When the personal details are deleted. */
  purge_after: string
  status: string
  hospital_name: string | null
  /** The person ticked "AMTC may contact me later" (coordination only). */
  contact_consent: boolean
}

export type DueForDeletion = {
  data: DueForDeletionItem[]
  total: number
  window_days: number
}

export const DUE_FOR_DELETION_KEY = ['admin', 'due-for-deletion'] as const

/** GET /api/v1/admin/due-for-deletion — soonest first. */
export async function fetchDueForDeletion(
  token: string | null,
): Promise<DueForDeletion> {
  return await apiFetch<DueForDeletion>('/api/v1/admin/due-for-deletion', {
    token,
  })
}
